(() => {
  const enhancerKey = 'BFProductReviewsEnhancer';

  const enhanceSection = (section) => {
    if (!section || section.dataset.bfReviewsEnhancerReady === 'true') return;

    const productImage = section.dataset.bfReviewProductImage;
    const syncReviewProductImage = () => {
      if (!productImage) return;

      // Judge.me can retain an old product thumbnail after Shopify media changes.
      // Use the current product image; customer-uploaded review photos stay intact.
      section.querySelectorAll('.jm-review-widget[data-image-url]').forEach((widget) => {
        widget.dataset.imageUrl = productImage;
      });
    };

    const syncReviewFormImage = () => {
      if (!productImage) return;
      document.querySelectorAll('.jdgm-write-review-modal__product-image > img').forEach((image) => {
        if (image.getAttribute('src') !== productImage) image.setAttribute('src', productImage);
      });
    };

    let formImageObserver;
    let formImageTimer;
    const stopFormImageSync = () => {
      formImageObserver?.disconnect();
      clearTimeout(formImageTimer);
    };
    const syncOpeningReviewForm = () => {
      stopFormImageSync();
      if (!productImage) return;

      // The app mounts the modal outside this section and fills it asynchronously.
      // Watch only during opening, including replacements of its cached image src.
      formImageObserver = new MutationObserver(syncReviewFormImage);
      formImageObserver.observe(document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['src'],
      });
      syncReviewFormImage();
      formImageTimer = setTimeout(stopFormImageSync, 2000);
    };
    section.bfReviewFormImageCleanup = stopFormImageSync;

    const applyAverageRating = () => {
      const widget = section.querySelector('.jdgm-review-widget[data-shop-average-rating]');
      const average = section.querySelector('.jm-average-rating-display');
      const cluster = average?.querySelector(':scope > .jm-cluster');
      const sourceStars = section.querySelector('.jm-review-item .jm-star-rating');
      const reviewCount = Number(widget?.dataset.shopReviewCount || 0);
      const rating = Number(widget?.dataset.shopAverageRating);

      if (!widget || !average || !cluster || !sourceStars || reviewCount < 1 || !Number.isFinite(rating)) return false;

      let stars = cluster.querySelector('.bf-product-reviews__average-stars');
      if (!stars) {
        stars = document.createElement('span');
        stars.className = 'bf-product-reviews__average-stars';
        stars.setAttribute('aria-hidden', 'true');

        const base = document.createElement('span');
        base.className = 'bf-product-reviews__average-stars-layer';
        const baseStars = sourceStars.cloneNode(true);
        baseStars.removeAttribute('role');
        baseStars.removeAttribute('aria-label');
        base.append(baseStars);

        const fill = document.createElement('span');
        fill.className = 'bf-product-reviews__average-stars-fill';
        const fillStars = sourceStars.cloneNode(true);
        fillStars.removeAttribute('role');
        fillStars.removeAttribute('aria-label');
        fill.append(fillStars);

        stars.append(base, fill);
        cluster.prepend(stars);
      }

      const fill = Math.min(100, Math.max(0, (rating / 5) * 100));
      stars.style.setProperty('--bf-average-star-fill', `${fill}%`);
      average.classList.add('is-bf-average-enhanced');
      return true;
    };

    const applyReviewButton = () => {
      section.querySelectorAll('.jm-action-buttons__button[data-testid="write-review-button"]').forEach((button) => {
        if (button.querySelector('.bf-product-reviews__button-icon')) return;

        const icon = document.createElement('span');
        icon.className = 'bf-product-reviews__button-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '◉';
        button.prepend(icon);
        button.addEventListener('click', syncOpeningReviewForm);
      });
    };

    const applyEnhancements = () => {
      syncReviewProductImage();
      applyAverageRating();
      applyReviewButton();
    };

    section.dataset.bfReviewsEnhancerReady = 'true';
    applyEnhancements();

    // Judge.me may replace its controls after loading or opening the form.
    // Keep the decorations idempotent across those app-owned updates.
    const observer = new MutationObserver(applyEnhancements);

    section.bfReviewsObserver = observer;
    observer.observe(section, { childList: true, subtree: true });
  };

  const init = (scope = document) => {
    if (scope.matches?.('[data-bf-product-reviews]')) enhanceSection(scope);
    scope.querySelectorAll?.('[data-bf-product-reviews]').forEach(enhanceSection);
  };

  if (!window[enhancerKey]) {
    window[enhancerKey] = { init };
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches?.('[data-bf-product-reviews]')
        ? event.target
        : event.target.querySelector?.('[data-bf-product-reviews]');
      section?.bfReviewsObserver?.disconnect();
      section?.bfReviewFormImageCleanup?.();
      if (section) {
        delete section.bfReviewsObserver;
        delete section.bfReviewFormImageCleanup;
        delete section.dataset.bfReviewsEnhancerReady;
      }
    });
  }

  window[enhancerKey].init();
})();
